export default __webpack_public_path__ + "locales/hy-AM/SmartBanner.json?hash=8d9ba4105338736ca76c033d925452fb";